/* eslint-disable max-len */
/**
 * English translations.
 */
export default {
  ACTION: {},
  ERROR: {},
  HEADER: {},
  LABEL: {
    ACCESS_NUMBER: 'Access no.',
    BLACK_FRIDAY_COMISSION_TITLE: 'Commissions black friday {0}',
    BLACK_FRIDAY_COMMISSION: 'Black Friday commissions {0}',
    BLACK_FRIDAY_COMMISSION_PREVIOUS: 'Black Friday commissions {0}',
    COMISSION_DESCRIPTION: 'Current month total:',
    COMISSION_LAST_MONTH: 'Homologous',
    COMISSION_LAST_TEN: 'Last {0} days',
    COMISSION_TITLE: 'Commissions over the last {0} days:',
    COMMISSION: 'Commission',
    COMMISSION_COLUMN: 'Commission (€)',
    DAILY: 'Daily',
    DATE: 'Date',
    FEMALE: 'Female',
    FIFTY_DAYS: '50 Days',
    GENDER: 'Gender',
    HITS: 'Hits over the last {0} days:',
    HITS_DESCRIPTION: 'Hits',
    HOMOLOGOUS: 'Homologous',
    HOMOLOGOUS_LAST_YEAR: 'Last year',
    MALE: 'Male',
    NAME: 'Name',
    NEW_CUSTOMERS: 'New client accounts {0} days:',
    NEW_CUSTOMERS_ANNIVERSARY: 'New client accounts Prozis anniversary',
    NEW_CUSTOMERS_DETAIL_DESCRIPTION: 'New accounts pending order {0} days:',
    NO_SALES: 'No sales',
    ORDER_PENDING_CUSTOMERS: 'Account pending order',
    ORDERED_CUSTOMERS: 'New client account',
    ORDERS: 'Orders over the last {0} days:',
    ORDERS_DESCRIPTION: 'Paid orders over the last 6 months',
    ORDERS_DETAIL_DESCRIPTION: 'Orders pending payment over the last {0} days:',
    ORDERS_PAY: 'Paid orders',
    ORDERS_PENDING: 'Pending orders',
    PERCENTAGE: 'Percentage',
    PRODUCT_CATEGORY: 'Category',
    PRODUCT_COLUMN: 'Product',
    QT_COLUMN: 'Quantity',
    QUANTITY: 'Quantity',
    SALES: 'Sales',
    SALES_DESCRIPTION: 'Current month',
    SALES_PRODUCT: 'Sales by product category',
    TEN_DAYS: '10 Days',
    THIRTEEN_DAYS: '30 Days',
    TOP_COMMISSION_TITLE: 'Products with the most commissions',
    TOP_DESCRIPTION: 'Current month',
    TOP_GENDER_DESCRIPTION: 'Last {0} days',
    TOP_GENDER_TITLE: 'Top Sales by Gender',
    TOP_TITLE: 'Top Most sold articles',
    TWENTY_DAYS: '20 Days',
    UPDATED_AT: 'Updated on {0}',
    VALUE: 'Amount'
  },
  SENTENCE: {
    EMPTY_DESCRIPTION: 'Data is missing',
    EMPTY_TITLE: 'No data'
  },
  SUCCESS: {},
  TOOLTIP: {}
};
